import { render, staticRenderFns } from "./EditAccommodation.vue?vue&type=template&id=72e9c54a&scoped=true"
import script from "./EditAccommodation.vue?vue&type=script&lang=js"
export * from "./EditAccommodation.vue?vue&type=script&lang=js"
import style0 from "./EditAccommodation.vue?vue&type=style&index=0&id=72e9c54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9c54a",
  null
  
)

export default component.exports